var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ig-page-base',{attrs:{"title":_vm.getTitle,"icon":_vm.module.icon,"loading":_vm.loading,"show-header":""}},[(!_vm.loading)?_c('div',{staticClass:"box integration-detail__content"},[_c('p',[_vm._v("Aguarde um instante")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }